import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=d8b1f5ae&scoped=true&"
import script from "./Modulos.vue?vue&type=script&lang=js&"
export * from "./Modulos.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=d8b1f5ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b1f5ae",
  null
  
)

export default component.exports